import "@lds/core/lds-button.js"
import "@lds/core/lds-select.js"
import "@lds/core/lds-option.js"
import "@lds/core/lds-dropdown.js"
import "@modules/location/location"
import "./category"
import "./filter"
import "@modules/user-search/user-search"
import "./snapshot-updated-notification"
import "./filter-selection"
import "./advert-card-view-type"
import "./pagination"
import "./advert-cards.css"
import "./solads"
import "./exoclick"
import "./affiliates"
import "./advert-card-merkzettel-highlighting"
import "./azm-info"
import "./advert-banners"
import { storeLastScrollPositionAzm } from "@modules/azm/store-last-scroll-position.ts"
import { Scrolling } from "@modules/util/Scrolling.ts"
import { isMobile } from "@modules/util/device.ts"

if (isMobile()) {
    Scrolling.siteScrolled.attach((__, _) => {
        storeLastScrollPositionAzm()
    })
}
